import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonKentimataTripleYpsili';
const args = {};

export class OligonKentimataTripleYpsili extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
